var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-xs-6" },
      [
        _c(
          "dialog-component",
          {
            attrs: {
              status: _vm.topicDialog,
              header: true,
              title: "Добавить тему"
            },
            on: {
              clickBackground: function($event) {
                _vm.topicDialog = false
              },
              close: function($event) {
                _vm.topicDialog = false
              }
            }
          },
          [
            _c(
              "div",
              { attrs: { slot: "body" }, slot: "body" },
              [
                _c("form-topic", { attrs: { settings: _vm.settings } }),
                _vm._v(" "),
                _c("div", { staticStyle: { height: "10px" } })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "dialog-component",
          {
            attrs: {
              status: _vm.cropDialog,
              header: true,
              title: "Загрузить фотографию"
            },
            on: {
              close: function($event) {
                _vm.cropDialog = false
              }
            }
          },
          [
            _c(
              "div",
              { attrs: { slot: "body" }, slot: "body" },
              [
                _c("crop-photo", {
                  attrs: { url: _vm.photoUrl },
                  on: {
                    save: function(url) {
                      _vm.cropDialog = false
                      _vm.settings.photo = url
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticStyle: { height: "20px" } })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Тема формы:")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-8" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.settings.form_theme,
                    expression: "settings.form_theme"
                  }
                ],
                staticClass: "oc-form__control",
                attrs: { name: "settings[form_theme]" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.settings,
                      "form_theme",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "material_design" } }, [
                  _vm._v("Material Design")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "light" } }, [_vm._v("Light")])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Класс для вызова формы обратной связи:")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.settings.form_tag_class,
                  expression: "settings.form_tag_class"
                }
              ],
              staticClass: "oc-form__control",
              attrs: {
                type: "text",
                name: "settings[form_tag_class]",
                placeholder: ".call-back-button, #call-back-button"
              },
              domProps: { value: _vm.settings.form_tag_class },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.settings, "form_tag_class", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Заголовок формы:")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.settings.form_title,
                  expression: "settings.form_title"
                }
              ],
              staticClass: "oc-form__control",
              attrs: {
                type: "text",
                name: "settings[form_title]",
                placeholder: "Заказать обратный звонок"
              },
              domProps: { value: _vm.settings.form_title },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.settings, "form_title", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Текст формы:")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-8" },
            [
              _c("redactor", {
                model: {
                  value: _vm.settings.form_text,
                  callback: function($$v) {
                    _vm.$set(_vm.settings, "form_text", $$v)
                  },
                  expression: "settings.form_text"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Фотография на форме:")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-8" },
            [
              _c("br"),
              _vm._v(" "),
              _c("upload-photo", {
                attrs: {
                  url: "#/ordercall",
                  "class-name": "oc-inline-link",
                  "upload-url":
                    "?plugin=ordercall&module=json&action=photo&method=upload",
                  "has-photo": !!_vm.settings.photo
                },
                on: {
                  upload: _vm.uploadPhoto,
                  del: function($event) {
                    _vm.settings.photo = ""
                  }
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass:
                "col-xs-4 control-label oc-settings__form-editor-header"
            },
            [_vm._v("Редактор полей:")]
          ),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              !!_vm.settings
                ? _c("form-creator", {
                    attrs: { settings: _vm.settings },
                    on: {
                      openTopic: function($event) {
                        _vm.topicDialog = true
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Название кнопки:")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.settings.form_button,
                  expression: "settings.form_button"
                }
              ],
              staticClass: "oc-form__control",
              attrs: {
                type: "text",
                name: "settings[form_button]",
                placeholder: "Отправить"
              },
              domProps: { value: _vm.settings.form_button },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.settings, "form_button", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Цвет кнопки:")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-8" }, [
            _c(
              "div",
              { staticClass: "oc-color" },
              [
                _c("color-input", {
                  attrs: { colors: _vm.colors_button },
                  on: { input: _vm.updateButtonColor }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Цвет текста:")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-8" }, [
            _c(
              "div",
              { staticClass: "oc-color" },
              [
                _c("color-input", {
                  attrs: { colors: _vm.colors_text },
                  on: { input: _vm.updateTextColor }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Текст сообщения при уcпешной отправке:")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-8" },
            [
              _c("redactor", {
                model: {
                  value: _vm.settings.form_text_success,
                  callback: function($$v) {
                    _vm.$set(_vm.settings, "form_text_success", $$v)
                  },
                  expression: "settings.form_text_success"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Цвет фона при успешной отправке:")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-8" }, [
            _c(
              "div",
              { staticClass: "oc-color" },
              [
                _c("color-input", {
                  attrs: { colors: _vm.colors_background_success },
                  on: { input: _vm.updateBgSsColor }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Цвет текста при успешной отправке:")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-8" }, [
            _c(
              "div",
              { staticClass: "oc-color" },
              [
                _c("color-input", {
                  attrs: { colors: _vm.colors_text_success },
                  on: { input: _vm.updateTxSsColor }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Цвет фона при ошибке:")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-8" }, [
            _c(
              "div",
              { staticClass: "oc-color" },
              [
                _c("color-input", {
                  attrs: { colors: _vm.colors_background_error },
                  on: { input: _vm.updateBgErColor }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-4 control-label" }, [
            _vm._v("Цвет текста при ошибке:")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-8" }, [
            _c(
              "div",
              { staticClass: "oc-color" },
              [
                _c("color-input", {
                  attrs: { colors: _vm.colors_text_error },
                  on: { input: _vm.updateTxErColor }
                })
              ],
              1
            )
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-xs-6" },
      [_c("form-viewer", { attrs: { settings: _vm.settings } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2af98498", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2af98498","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/form/Form.vue
// module id = 135
// module chunks = 0